/**
 * 客源渠道模块
 */
import React, { useContext, useMemo } from 'react';
import { Input, Select } from 'antd';
import intl from 'react-intl-universal';

import ContentBlock, { FormItem } from '@/components/Reservation/ContentBlock';
import CommonPriceInput from '@/components/Reservation/NumberInput/CommonPriceInput';
import IntlContext from '@/components/Intl/IntlContext';
import { SourceChannelType } from '@/config/constant';
import { ChannelItem, StrategyItem, SourceChannelInfo } from '@/redux/reducers/reservation/base.d';
import { findItemByKey } from '@/redux/actions/reservation/helper';

import styles from './index.module.scss';

interface IProps {
  value: SourceChannelInfo;
  channelList: ChannelItem[];
  strategyList: StrategyItem[];
  onChange: (value: Partial<SourceChannelInfo>) => void;
  getPopContainer: () => any;
}

interface ISelectOption {
  label: string;
  value: string | number;
}

const Index: React.FC<IProps> = (props) => {
  const { value, channelList, strategyList, onChange, getPopContainer } = props;

  const channelOptions: ISelectOption[] = useMemo(() => {
    return (channelList || []).map((item) => ({
      label: item.name,
      value: item.id,
    }));
  }, [channelList]);

  const strategyOptions: ISelectOption[] = useMemo(() => {
    return (strategyList || []).map((item) => ({
      label: item.showName,
      value: item.id,
    }));
  }, [strategyList]);

  const intlCtx = useContext(IntlContext);

  const handleChannelChange: (channelId: number) => void = (channelId) => {
    onChange({ channelId });
  };

  const handleChargeStrategyChange: (strategyId: number) => void = (strategyId) => {
    onChange({ strategyId });
  };

  const handleOTAOrderChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    onChange({ channelOrderNo: event.target.value });
  };

  const handleAdvanceChargeChange: (otaPaymentAmount: string) => void = (otaPaymentAmount) => {
    // if (PRICE_REG.test(otaPaymentAmount)) {
    onChange({ otaPaymentAmount });
    // }
  };

  const handleInvoiceAmountChange = (invoiceAmount) => {
    onChange({ invoiceAmount });
  };

  const channelType = useMemo(() => {
    const channelItem = findItemByKey(channelList, 'id', value.channelId);
    if (channelItem) return channelItem.type;
    return SourceChannelType.WALK_IN; // 默认线下
  }, [channelList, value.channelId]);
  const isNotOTA = channelType !== SourceChannelType.OTA; // 非ota渠道
  const isWalkIn = channelType === SourceChannelType.WALK_IN; // 线下

  return (
    <ContentBlock
      title={intl.get('reservation_channel_block_title')}
      className={styles.channelInfo}
    >
      <FormItem label={intl.get('app_reservation_channel_name')}>
        <Select
          placeholder={intl.get('reservation_channel_field_channel_id_placeholder')}
          options={channelOptions}
          value={value.channelId}
          onChange={handleChannelChange}
          getPopupContainer={getPopContainer}
        />
      </FormItem>
      <FormItem label={intl.get('app_reservation_strategy_name')}>
        <Select
          placeholder={intl.get('reservation_channel_field_strategy_id_placeholder')}
          options={strategyOptions}
          value={value.strategyId}
          onChange={handleChargeStrategyChange}
          getPopupContainer={getPopContainer}
        />
      </FormItem>
      <br />

      {isWalkIn ? null : (
        <>
          <FormItem label={intl.get('app_reservation_channel_no')}>
            <Input
              disabled={isNotOTA}
              placeholder={intl.get('reservation_field_input_default_placeholder')}
              value={value.channelOrderNo}
              onChange={handleOTAOrderChange}
            />
          </FormItem>
          <FormItem
            label={intl.get('reservation_channel_field_ota_amount_label')}
            className={styles.alignStartItem}
          >
            <CommonPriceInput
              placeholder={intl.get('reservation_field_input_default_placeholder')}
              keepInput
              prefix={intlCtx.TenantBaseConfig.CurrencySymbol}
              autoFocus={false}
              disabled={isNotOTA}
              className={styles.prePayInput}
              value={value.otaPaymentAmount}
              onChange={handleAdvanceChargeChange}
            />
          </FormItem>
          <FormItem
            label={intl.get('reservation_channel_field_invoice_amount_label')}
            className={styles.alignStartItem}
          >
            <CommonPriceInput
              placeholder={intl.get('reservation_channel_field_invoice_amount_placeholder')}
              keepInput
              prefix={intlCtx.TenantBaseConfig.CurrencySymbol}
              autoFocus={false}
              disabled={isNotOTA}
              className={styles.prePayInput}
              value={value.invoiceAmount}
              onChange={handleInvoiceAmountChange}
            />
          </FormItem>
        </>
      )}
    </ContentBlock>
  );
};

export default Index;
